export default function prepareFileName (fullFileName){
    let fileName = fullFileName.split('_');
    if(!isNaN(fileName[fileName.length - 1])) fileName.splice(fileName.length - 1, 1);
    return fileName.join('_');
}